import moment from "moment";
import { dateFormat, logging, makeItemId } from "../tools";

const serverDateFormat = "YYYY-MM-DD HH:mm:ss";

export default function exportedEvents(events) {
  let events2export = [];

  events.forEach((event) => {
    let exportedEvent = {
      ...event,
      beepId: event?.type === "SERVER_EVENT" ? Number(event.id) : makeItemId(),
      startTime: moment(event.start, dateFormat).format(serverDateFormat),
      endTime:
        event.end === null
          ? moment(event.start, dateFormat)
              .add(2, "hours")
              .format(serverDateFormat)
          : moment(event.end, dateFormat).format(serverDateFormat),
      randomizationScheme: event.end === null ? 0 : 1,
      reminderIntervals: event?.reminderIntervals ?? null,
      expirationInterval: event?.expirationInterval ?? null,
      useAsButton: event?.useAsButton ?? 0,
      buttonText: event?.buttonText ?? null,
      buttonLabel: event?.buttonLabel ?? null,
      singleUse: event?.singleUse ?? 0,
      scheduleType: event?.scheduleType ?? null,
    };
    delete exportedEvent.start;
    delete exportedEvent.end;
    delete exportedEvent.title;
    delete exportedEvent.backgroundColor;
    delete exportedEvent.id;

    const sentTime = event?.sentTime ?? null;
    const resultReceivedTime = event?.resultReceivedTime ?? null;
    // beeo nog niet verzonden en geen resultaat ontvangen
    if (!sentTime && !resultReceivedTime) {
      events2export.push(exportedEvent);
    }
  });
  logging("Export events");
  logging(events2export);
  return events2export;
}
